import type { PostType } from '@prisma/client';
import { env } from '@/env';

interface genShareDataParams {
  title: string;
  text: string;
  url: string;
}

export function genShareData(params: genShareDataParams) {
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(params.url)}`;

  const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    params.text,
  )}&url=${encodeURIComponent(params.url)}`;

  const whatsappShareUrl = `https://wa.me/?text=${encodeURIComponent(`${params.title} - ${params.url}`)}`;

  const emailShareUrl = `mailto:?subject=${encodeURIComponent(
    params.text,
  )}&body=${encodeURIComponent(
    `I thought you might find this interesting: ${params.title}\n\n${params.url}`,
  )}`;

  return {
    facebookShareUrl,
    twitterShareUrl,
    whatsappShareUrl,
    emailShareUrl,
  };
}

export function getPostUrl(slug: string, postType: PostType) {
  const postTypesSlug = {
    Article: 'articles',
    News: 'news',
  };

  return `/posts/${postTypesSlug[postType]}/${slug}`;
}

// return type if image = string if not then undefined
type returnType<T> = T extends 'image' ? string : string | undefined;

export function getFileUrl<T extends 'image' | 'video' | 'audio' | 'document'>(
  key: string | undefined,
  type?: T,
): returnType<T> {
  if (!key) {
    if (type === 'image') {
      return '/images/no-image.svg';
    }
    return undefined as returnType<T>;
  }

  return `${env.NEXT_PUBLIC_STORAGE_BASE_URL}/${key}`;
}
